import PropTypes from 'prop-types';

const DaypartTableText = ({ value }) => (
  <div className='flex flex-col'>
    {value.split(' ').map((word, index) => (
      <span key={`${word}${index}`} className='text-[#737373] font-[Manrope] text-sm font-semibold'>
        {word}
      </span>
    ))}
  </div>
);

DaypartTableText.propTypes = {
  value: PropTypes.string.isRequired,
};

export default DaypartTableText;
